/**
 * Created by Administrador on 3/31/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('legendsController', legendsController);

    legendsController.$inject = ['tabs', 'legends'];

    function legendsController(tabs, legends){
        var vm = this;
        vm.tabs = tabs;
        vm.pages = [];
        vm.legends = (legends.data._embedded) ? legends.data._embedded.legends: [];
        vm.pages = legends.data.page;
    }
})();
